import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    ApiKey,
    ApiUrl,
    TransactionType,
    BankingChannel,
    PanelType,
    FixedDepositAmount
} from "../../util/Constant";
import {
    stringIsNullOrEmpty,
    createMultiPartFormBody,
    numberWithCurrencyFormat,
    numberWithCurrencyFormat2,
    numberWithCommas
} from "../../util/Util";
import ApiEngine from "../../util/ApiEngine";
import { useForm, Controller } from "react-hook-form";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import Dropzone from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { setBusy, setIdle, showResponseMessage } from "../../redux/AppAction";
import { Modal, ModalBody, Alert } from "reactstrap";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
import BlueWarningIcon from "../../assets/img/v3/notice_blue.svg";
import TickIcon from "../../assets/img/assets/tick.svg";
import TickIcon1 from "../../assets/img/assets/tick_1.svg";
import CopyIcon from "../../assets/img/v3/copyIcon2.svg"
import CompleteIcon from "../../assets/img/v3/complete_Icon.gif"

// Bank icon imports
import AffinIcon from "../../assets/img/v3/full-bank-icon/Affin.svg";
import AllianceBankIcon from "../../assets/img/v3/full-bank-icon/Alliance Bank.svg";
import AlrajhiBankIcon from "../../assets/img/v3/full-bank-icon/Alrajhi Bank.svg";
import AmbankIcon from "../../assets/img/v3/full-bank-icon/Ambank.svg";
import ArgoIcon from "../../assets/img/v3/full-bank-icon/ArgoBank.svg";
import BANKISLAMIcon from "../../assets/img/v3/full-bank-icon/Bank Islam.svg";
import BankMuamalatIcon from "../../assets/img/v3/full-bank-icon/Bank Muamalat.svg";
import BRAKYATIcon from "../../assets/img/v3/full-bank-icon/Bank Rakyat.svg";
import BSNIcon from "../../assets/img/v3/full-bank-icon/BSN.svg";
import CIMBIcon from "../../assets/img/v3/full-bank-icon/CIMB.svg";
import CITIIcon from "../../assets/img/v3/full-bank-icon/CitiBank.svg";
import COPIcon from "../../assets/img/v3/full-bank-icon/COP.svg";
import GXBANKIcon from "../../assets/img/v3/full-bank-icon/GXBank.svg";
import HLBIcon from "../../assets/img/v3/full-bank-icon/HLB.svg";
import HSBCIcon from "../../assets/img/v3/full-bank-icon/HSBC.svg";
import MBBIcon from "../../assets/img/v3/full-bank-icon/Maybank.svg";
import MBSBIcon from "../../assets/img/v3/full-bank-icon/MBSB.svg";
import OCBCIcon from "../../assets/img/v3/full-bank-icon/OCBC.svg";
import PBEIcon from "../../assets/img/v3/full-bank-icon/pbe.svg";
import RHBIcon from "../../assets/img/v3/full-bank-icon/RHB.svg";
import StandardIcon from "../../assets/img/v3/full-bank-icon/Standard.svg";
import UOBIcon from "../../assets/img/v3/full-bank-icon/UOB.svg";

// E-wallet imports
import BoostIcon from "../../assets/img/v3/ewallet-icon/Boost.svg";
import BRAKYATIcon2 from "../../assets/img/v3/ewallet-icon/BRAKYAT.svg";
import DUITNOWIcon from "../../assets/img/v3/ewallet-icon/DUITNOW.svg";
import GPAYIcon from "../../assets/img/v3/ewallet-icon/GPAY.svg";
import GrabpayIcon from "../../assets/img/v3/ewallet-icon/Grabpay.svg";
import ShopeePIcon from "../../assets/img/v3/ewallet-icon/ShopeeP.svg";
import ShopeePayIcon from "../../assets/img/v3/ewallet-icon/ShopeePay.svg";
import TNGoFullWhiteIcon from "../../assets/img/v3/ewallet-icon/TNGo_FullWhite.svg";
import TNGoWHiteIcon from "../../assets/img/v3/ewallet-icon/TNGo_WHite.svg";
import TNGo1Icon from "../../assets/img/v3/ewallet-icon/TNGo-1.svg";

const NormalDeposit = (props) => {
    const { t } = useTranslation();
    let _dispatch = useDispatch();
    const {
        handleSubmit,
        control,
        watch,
        setValue,
        errors,
        clearErrors,
        setError,
        register
    } = useForm();
    const [bankAccountOption, setBankAccountOption] = useState([]);
    const [bankAccountId, setBankAccountId] = useState(0);
    const [receiptImage, setReceiptImage] = useState();
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(0);
    const [isReloadSuccess, setIsReloadSuccess] = useState(false);
    const [paidAmount, setPaidAmount] = useState(0);
    const [reloadDate, setReloadDate] = useState();
    const [transcactionNumber, setTranscactionNumber] = useState();
    const [imageFileSize, setImageFileSize] = useState(0);
    const ONE_MB_IN_BYTES = 1048576;
    const fileSizeLimit_InMB = 20;
    const [showCopyAlert, setShowCopyAlert] = useState(false);
    const _ALERT_TIMEOUT = 3000;
    const [scrollPosition, setScrollPosition] = useState(0);
    const _userData = useSelector(state => state.authState.userData);
    const [bankIsSelected, setBankIsSelected] = useState(false);
    const [selectedBank, setSelectedBank] = useState({});
    const [amountValue, setAmountValue] = useState("");
    const [bankReference, setBankReference] = useState("");
    const fixedAmount = FixedDepositAmount;


    const [tngSetting, setTngSetting] = useState({});
    const [tngStatus, setTngStatus] = useState(false);
    const [tngImg, setTngImg] = useState("");
    const [depositReference, setDepositReference] = useState("");
    const [canDisplayBank, setCanDisplayBank] = useState(true);
    const [copyAlert, setCopyAlert] = useState("");
    const [tngBankAccountOption, setTngBankAccountOption] = useState([]);
    const [duitNowBankAccountOption, setDuitNowBankAccountOption] = useState([]);

    const banksList = [
        {
            label: "CIMB",
            img: CIMBIcon
        },
        {
            label: "MAYBANK",
            img: MBBIcon
        },
        {
            label: "PUBLIC BANK",
            img: PBEIcon
        },
        {
            label: "HONG LEONG BANK",
            img: HLBIcon
        },
        {
            label: "RHB",
            img: RHBIcon
        },
        {
            label: "AMBANK",
            img: AmbankIcon
        },
        {
            label: "AFFIN BANK",
            img: AffinIcon
        },
        {
            label: "ALLIANCE BANK",
            img: AllianceBankIcon
        },
        {
            label: "BANK ISLAM",
            img: BANKISLAMIcon
        },
        {
            label: "BANK RAKYAT",
            img: BRAKYATIcon
        },
        {
            label: "BANK SIMPANAN NASIONAL ",
            img: BSNIcon
        },
        {
            label: "CITIBANK",
            img: CITIIcon
        },
        {
            label: "HSBC",
            img: HSBCIcon
        },
        {
            label: "OCBC",
            img: OCBCIcon
        },
        {
            label: "STANDARD CHARTERED BANK",
            img: StandardIcon
        },
        {
            label: "UOB",
            img: UOBIcon
        },
        {
            label: "AGRO BANK",
            img: ArgoIcon
        },
        {
            label: "GX BANK",
            img: GXBANKIcon
        }
    ];

    const ewalletList = [
        {
            label: "BOOST",
            img: BoostIcon
        },
        {
            label: "BANK RAKYAT",
            img: BRAKYATIcon2
        },
        {
            label: "DUITNOW",
            img: DUITNOWIcon
        },
        {
            label: "GPAY",
            img: GPAYIcon
        },
        {
            label: "GRABPAY",
            img: GrabpayIcon
        },
        {
            label: "SHOPEEPAY",
            img: ShopeePayIcon
        },
        {
            label: "SHOPEEP",
            img: ShopeePIcon
        },
        {
            label: "TNG",
            img: TNGo1Icon
        },
        {
            label: "TNGWHITE",
            img: TNGoWHiteIcon
        },
        {
            label: "TNGO",
            img: TNGoFullWhiteIcon
        }
    ];


    //useEffect

    useEffect(() => {
        init();
    }, []);


    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        setTngBankAccountOption(bankAccountOption.filter(x => x.bankName === "TNG" && x.isTng && !stringIsNullOrEmpty(x.tngQrImage)));
        setDuitNowBankAccountOption(bankAccountOption.filter(x => x.isDuitNow && !stringIsNullOrEmpty(x.duitNowQrImage)));
    }, [bankAccountOption]);

    async function init() {
        getBankAccount();
        getTng();
        setBankReference(generateReferenceCode());
    }

    async function getBankAccount() {
        let responseJson = await ApiEngine.get(
            ApiUrl._API_GET_BANK_ACCOUNT +
            "?deposit=" +
            true
        );
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setBankAccountOption(responseJson[ApiKey._API_DATA_KEY].sort((a, b) => a.bankNormalRank - b.bankNormalRank));
            if (responseJson[ApiKey._API_DATA_KEY].length <= 0) {
                props.setDisplayNormalDeposit(false);
            }
        }
    }

    async function getTng() {
        var TNG_START_HOUR_LIMIT_IN_UTC0 = 0;
        var TNG_END_HOUR_LIMIT_IN_UTC0 = 23;


        let TnGresponseJson = await ApiEngine.get(
            ApiUrl._API_GET_COMPANY_TNG_SYSTEM_SETTINGS
        );
        let startTimeStr = "";
        let endTimeStr = "";
        let TnGStatus = false;

        if (TnGresponseJson[ApiKey._API_SUCCESS_KEY] && TnGresponseJson[ApiKey._API_DATA_KEY].length > 0) {
            let data = TnGresponseJson[ApiKey._API_DATA_KEY];

            data.map((keyValuePair, index) => {
                if (keyValuePair["key"] === "TnGStartTime") {
                    startTimeStr = keyValuePair["value"];
                    TNG_START_HOUR_LIMIT_IN_UTC0 = moment(
                        moment().format("YYYY-MM-DD") + " " + startTimeStr,
                        "YYYY-MM-DD HH:mm:ss"
                    );
                }
                if (keyValuePair["key"] === "TnGEndTime") {
                    endTimeStr = keyValuePair["value"];
                    TNG_END_HOUR_LIMIT_IN_UTC0 = moment(
                        moment().format("YYYY-MM-DD") + " " + endTimeStr,
                        "YYYY-MM-DD HH:mm:ss"
                    );
                }
                if (keyValuePair["key"] === "TnGStatus") {
                    TnGStatus = keyValuePair["value"] === "true";
                }
            });
        }

        if (
            moment(TNG_END_HOUR_LIMIT_IN_UTC0).isBefore(
                TNG_START_HOUR_LIMIT_IN_UTC0
            )
        ) {
            TNG_END_HOUR_LIMIT_IN_UTC0 = moment(TNG_END_HOUR_LIMIT_IN_UTC0).add(
                1,
                "day"
            );
        }

        if (
            TnGStatus &&
            moment().isAfter(TNG_START_HOUR_LIMIT_IN_UTC0) &&
            moment().isBefore(TNG_END_HOUR_LIMIT_IN_UTC0)
        ) {
            setTngStatus(true);
            let responseJson = await ApiEngine.get(
                ApiUrl._API_GET_USER_BANK + "?type=TNG"
            );
            if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                setTngSetting(responseJson[ApiKey._API_DATA_KEY]);
                let apiUrl = ApiUrl._API_GET_USER_SYSTEM_SETTINGS + "?type=DailyQR";
                let TnGJson = await ApiEngine.get(apiUrl);
                if (
                    TnGJson[ApiKey._API_SUCCESS_KEY] &&
                    TnGJson[ApiKey._API_DATA_KEY] != null
                ) {
                    let data = TnGJson[ApiKey._API_DATA_KEY];
                    setTngImg(data);
                }
            }

            let apiUrl = ApiUrl._API_GET_USER_SYSTEM_SETTINGS + "?type=depositReference";
            let settingJson = await ApiEngine.get(apiUrl);
            if (settingJson[ApiKey._API_SUCCESS_KEY] && settingJson[ApiKey._API_DATA_KEY] != null) {
                let data = settingJson[ApiKey._API_DATA_KEY];
                setDepositReference(data);
            }
        }
    }


    const imageDrop = (acceptedFiles) => {
        if (acceptedFiles.length !== 0) {
            const file = acceptedFiles[0];
            const fileSizeInMB = file.size / ONE_MB_IN_BYTES;
            setImageFileSize(fileSizeInMB);
            setValue("receipt", file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setReceiptImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const remove = () => {
        setReceiptImage("");
        setValue("receipt", null);
    };

    function resetFormField() {
        setBankAccountOption([]);
        setBankAccountId(0);
        setValue("receipt", null);
        setReceiptImage("");
        setAmountValue(0);
        setValue("depositDateTime", moment().format("YYYY-MM-DD HH:mm:ss"));
    }

    const checkAmountForErrors = async (tempAmountValue) => {
        clearErrors();
        if (parseFloat(tempAmountValue) < min) {
            setError("amount", {
                message: "VALUE_LESS_THAN_MINIMUM",
            });
        }
        else if (parseFloat(tempAmountValue) > max) {
            setError("amount", {
                message: "EXCEED_MAXIMUM_VALUE",
            });
        }
    }

    const checkValueOnSelectFixedAmt = async (fixedAmt) => {
        let updatedValue = (parseFloat(fixedAmt) + parseFloat(stringIsNullOrEmpty(amountValue) ? 0 : amountValue)).toString();
        setAmountValue(
            updatedValue
        );
        clearErrors();
        let tempAmountValue = updatedValue;
        if (parseFloat(tempAmountValue) < min) {
            setError("amount", {
                message: "VALUE_LESS_THAN_MINIMUM",
            });
        }
        else if (parseFloat(tempAmountValue) > max) {
            setError("amount", {
                message: "EXCEED_MAXIMUM_VALUE",
            });
        }
    }


    async function onSubmit(data, e) {
        _dispatch(setBusy());
        let params = {
            transactionTypeId: TransactionType._DEPOSIT,
            amount: parseFloat(amountValue),
            channel: BankingChannel._CHANNEL_OFFLINE_BANKING,
            panel: PanelType._MEMBERSITE,
            bankAccountId: bankAccountId,
            receiptReference: depositReference,
            referenceCode: bankReference
        };

        if (!stringIsNullOrEmpty(data.receipt)) {
            params["receipt"] = data.receipt;
        }

        if (!stringIsNullOrEmpty(props.bonusDeposit) && props.bonusDeposit != "-1") {
            params["bonusId"] = props.bonusDeposit;
        } else if (props.bonusDeposit === "-1") {
            params["bonusId"] = "";
        }

        let responseJson = await ApiEngine.post(
            ApiUrl._API_CREATE_TRANSACTION,
            createMultiPartFormBody(params)
        );
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setPaidAmount(params.amount);
            setIsReloadSuccess(true);
            setReloadDate(moment().format("DD MMM YYYY, hh:mm A"));
            setTranscactionNumber(responseJson[ApiKey._API_DATA_KEY]);
            props.checkPendingTxn();
            e.target.reset();
            resetFormField();
        } else {
            _dispatch(
                showResponseMessage(
                    responseJson[ApiKey._API_SUCCESS_KEY],
                    t(responseJson[ApiKey._API_MESSAGE_KEY])
                )
            );
        }
        _dispatch(setIdle());
    }

    const handleModalOnClick = () => {
        setIsReloadSuccess(false);
        //props.parentInit();
        init();
    };

    function setMinMaxButton(min, max, bankAccountId) {
        setMin(min);
        setMax(max);
        setBankAccountId(bankAccountId);
    }

    function copyText(label) {
        navigator.clipboard.writeText(label);
        document.execCommand("copy");

        if (stringIsNullOrEmpty(copyAlert) || copyAlert != label) {
            setCopyAlert(label);
            setTimeout(() => setCopyAlert(""), [5000]);
        }
    }

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };


    const handleBankSelection = async (bankAccount) => {
        setBankIsSelected(true);
        setSelectedBank(bankAccount);
        setMinMaxButton(bankAccount.minimumDeposit, bankAccount.maximumDeposit, bankAccount.id)
    }

    function generateReferenceCode() {
        // Get current Unix timestamp (seconds since Jan 1, 1970)
        const unixTimestamp = Math.floor(Date.now() / 1000);

        // Generate a random number between 1 and 4 (inclusive)
        const randomNumber = Math.floor(Math.random() * 4) + 1;

        const referenceCode = unixTimestamp * randomNumber;

        // Combine the parts with spaces
        return `${referenceCode}`;
    }

    useEffect(() => {
        if (Object.keys(props.memberNormalDepositTransactionHistory).length > 0 && bankAccountOption.length > 0) {
            checkNormalDeposit();
        }
    }, [props.memberNormalDepositTransactionHistory, bankAccountOption, tngStatus]);

    const checkNormalDeposit = async () => {
        const data = props.memberNormalDepositTransactionHistory;
        if (data.bankName == "TNG") {
            if (tngStatus) {
                const option = bankAccountOption.filter(i => i.bankName == data.bankName && i.accountNumber == data.accountNumber)[0];
                if (typeof option !== "undefined") {
                    handleBankSelection(option);
                }
            }
        } else {
            const option = bankAccountOption.filter(i => i.bankName == data.bankName && i.accountNumber == data.accountNumber)[0];
            if (typeof option !== "undefined") {
                handleBankSelection(option);
            }
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                {showCopyAlert && (
                    <div style={{ position: scrollPosition < 224 ? "relative" : "sticky", top: scrollPosition < 150 ? "107px" : scrollPosition >= 150 && scrollPosition < 160 ? "-65px" : scrollPosition >= 160 && scrollPosition < 170 ? "-55px" : scrollPosition >= 170 && scrollPosition < 180 ? "-45px" : scrollPosition >= 180 && scrollPosition < 190 ? "-35px" : scrollPosition >= 190 && scrollPosition < 200 ? "-25px" : scrollPosition >= 200 && scrollPosition < 210 ? "-15px" : scrollPosition >= 210 && scrollPosition < 224 ? "-5px" : "160px", left: "-55px", width: "100%", color: "white", zIndex: "99999" }}>
                        <div
                            className="content content-full-width"
                            style={{
                                position: "absolute",
                                width: "200px",
                                top: "10px",
                                right: "-40px"
                            }}
                        >
                            <Alert color="green" style={{ textAlign: "center" }}>
                                {t("COPY_SUCCESS")}
                            </Alert>
                        </div>
                    </div>
                )}
                <div className="normal-deposit-wrapper">

                    {bankIsSelected === false && (
                        <>
                            <div className="all-normal-banks-container">
                                {bankAccountOption.filter(x => x.bankName !== "TNG" && x.isDuitNow !== true) && bankAccountOption.filter(x => x.bankName !== "TNG" && x.isDuitNow !== true).length > 0 && (
                                    <>
                                        <div className="normal-bank-item-container">
                                            <div className="font14 normal-parent-bank-title">
                                                {t("BANK")}
                                            </div>
                                            <div className="deposit-normal-bank-list-container">
                                                {bankAccountOption.filter(x => x.bankName !== "TNG" && x.isDuitNow !== true).map((child, index) => {
                                                    // Find the corresponding bank image from banksList
                                                    const matchingBank = banksList.find(bank => bank.label === child.bankName);

                                                    return (
                                                        <div
                                                            key={"normal-deposit-bank" + index}
                                                            className="deposit-normal-bank-list-items"
                                                            onClick={() => { handleBankSelection(child) }}
                                                        >
                                                            <div className="bank-min">{t("MIN")} {numberWithCommas(child.minimumDeposit)}</div>
                                                            <img
                                                                src={matchingBank ? matchingBank.img : child.bankImg2}
                                                                alt="normal payment banks"
                                                                className="img-responsive"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    );
                                                })
                                                }
                                            </div>
                                        </div>
                                        <hr className="custom-hr" />
                                    </>
                                )}
                                {((tngStatus && tngBankAccountOption.length > 0) || duitNowBankAccountOption.length > 0) && (
                                    <>
                                        <div className="normal-bank-item-container">
                                            <div className="font14 normal-parent-bank-title">
                                                {t("DuitNow") + " / " + t("TNG")}
                                            </div>
                                            <div className="deposit-normal-bank-list-container">

                                                {tngBankAccountOption.map((child, index) => {
                                                    // Find the corresponding e-wallet image (TNG is in ewalletList)
                                                    const matchingWallet = ewalletList.find(wallet => wallet.label === child.bankName);

                                                    return (
                                                        <div
                                                            key={"tng-bank" + index}
                                                            className="deposit-normal-bank-list-items"
                                                            onClick={() => { handleBankSelection(child) }}
                                                        >
                                                            <div className="bank-min">{t("MIN")} {numberWithCommas(child.minimumDeposit)}</div>
                                                            <img
                                                                src={matchingWallet ? matchingWallet.img : child.bankImg2}
                                                                alt="normal payment banks"
                                                                className="img-responsive"
                                                                style={{ height: "100%" }}
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    )
                                                })}
                                                {duitNowBankAccountOption.map((child, index) => {
                                                    // Find the corresponding e-wallet image (DuitNow is in ewalletList)
                                                    const matchingWallet = ewalletList.find(wallet => wallet.label === child.bankName);

                                                    return (
                                                        <div
                                                            key={"duitnow-bank" + index}
                                                            className="deposit-normal-bank-list-items"
                                                            onClick={() => { handleBankSelection(child) }}
                                                        >
                                                            <div className="bank-min">{t("MIN")} {numberWithCommas(child.minimumDeposit)}</div>
                                                            <img
                                                                src={matchingWallet ? matchingWallet.img : child.bankImg2}
                                                                alt="normal payment banks"
                                                                className="img-responsive"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                    {bankIsSelected && (
                        <>
                            <div className="normal-bank-per-section-box">
                                <div className="first">
                                    {t("SELECTED_BANK_METHOD")}
                                </div>
                                <div className="second ">
                                    <div className="instant-provider-selected-wrapper-orange">
                                        <div className="instant-provider active" onClick={() => { setBankIsSelected(false); setSelectedBank({}); }}>
                                            <img className="tick-image" src={TickIcon1} alt="active" loading="lazy" />
                                            {/* Replace the bank image based on the selected bank's name */}
                                            {selectedBank.bankName && (
                                                <img
                                                    className="instant-provider-image"
                                                    src={
                                                        selectedBank.isDuitNow || selectedBank.bankName === "TNG"
                                                            ? (ewalletList.find(wallet => wallet.label === selectedBank.bankName)?.img || selectedBank.bankImg2)
                                                            : (banksList.find(bank => bank.label === selectedBank.bankName)?.img || selectedBank.bankImg2)
                                                    }
                                                    alt="selected bank"
                                                    loading="lazy"
                                                />
                                            )}
                                        </div>
                                        <div className="other-bank-button" onClick={() => { setBankIsSelected(false); setSelectedBank({}); }}>
                                            <div className="text">{t("OTHER_BANK")}</div>
                                            <img className="" src="../../img/v3/arrow-right.png" alt="arrowRight" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <hr className="custom-hr" />
                            {selectedBank.bankName === "TNG" && <>
                                <div className="normal-bank-per-section-box">
                                    <div className="first">
                                        {t("TNG_QR")}
                                    </div>
                                    <div className="second ">
                                        <div className="form-group m-b-15 text-center image-center pt-4">
                                            {selectedBank.isTng && (
                                                <img src={`${selectedBank.tngQrImage}?t=${new Date().getTime()}`} width="50%" alt="tng-qr" />
                                            )}
                                            {/*<img src={tngImg} width="50%" alt="tng-qr" />*/}
                                        </div>
                                        <div className="form-group m-b-15 text-center">
                                            <a
                                                href="https://youtu.be/ertSjk2cF7g"
                                                target="_blank"
                                                style={{ textDecoration: "underline" }}
                                            >
                                                {t("HOW_TO_TNG")}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <hr className="custom-hr" />
                            </>}
                            {selectedBank.isDuitNow && <>
                                <div className="normal-bank-per-section-box">
                                    <div className="first">
                                        {t("DUITNOW_QR")}
                                    </div>
                                    <div className="second ">
                                        <div className="form-group m-b-15 text-center image-center pt-4">
                                            <img src={`${selectedBank.duitNowQrImage}?t=${new Date().getTime()}`} width="50%" alt="duitnow-qr" />
                                        </div>
                                    </div>
                                </div>
                                <hr className="custom-hr" />
                            </>}
                            <div className="normal-bank-per-section-box">
                                <div className="first">
                                    {t("BANK_ACCOUNT_DETAILS") + " (" + selectedBank.bankName + ")"}
                                </div>
                                <div className="second ">
                                    {bankAccountOption &&
                                        bankAccountOption.length &&
                                        bankIsSelected &&
                                        <div className="deposit-normal-bank-details-container">
                                            <div className="deposit-normal-bank-details-item">
                                                <div className="first">
                                                    {t("BANK_NAME")}
                                                </div>
                                                <div className="second">
                                                    <div>
                                                        {selectedBank.bankName}
                                                    </div>
                                                    <div className="copy" onClick={() => copyText(selectedBank.bankName)}>
                                                        <img
                                                            src={copyAlert == selectedBank.bankName ? `${CompleteIcon}?t=${new Date().getTime()}` : CopyIcon}
                                                            alt="i8 banks"
                                                            className="img-responsive"
                                                            loading="lazy"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {selectedBank.bankName !== "TNG" && selectedBank.isDuitNow !== true && (
                                                <>
                                                    <div className="deposit-normal-bank-details-item mt-3">
                                                        <div className="first">
                                                            {t("BANK_ACCOUNT_NUMBER")}
                                                        </div>
                                                        <div className="second">
                                                            <div>
                                                                {selectedBank.accountNumber}
                                                            </div>
                                                            <div className="copy" onClick={() => copyText(selectedBank.accountNumber)}>
                                                                <img
                                                                    src={copyAlert == selectedBank.accountNumber ? `${CompleteIcon}?t=${new Date().getTime()}` : CopyIcon}
                                                                    alt="i8 banks"
                                                                    className="img-responsive"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="deposit-normal-bank-details-item mt-3">
                                                        <div className="first">
                                                            {t("BANK_ACCOUNT_HOLDER_NAME")}
                                                        </div>
                                                        <div className="second">
                                                            <div>
                                                                {selectedBank.accountHolderName}
                                                            </div>
                                                            <div className="copy" onClick={() => copyText(selectedBank.accountHolderName)}>
                                                                <img
                                                                    src={copyAlert == selectedBank.accountHolderName ? `${CompleteIcon}?t=${new Date().getTime()}` : CopyIcon}
                                                                    alt="i8 banks"
                                                                    className="img-responsive"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            <div className="deposit-normal-bank-details-item mt-3">
                                                <div className="first">
                                                    {t("MIN")}/{t("MAX")} {t("DEPOSIT")}
                                                </div>
                                                <div className="second font-bold">
                                                    MYR {numberWithCommas(selectedBank.minimumDeposit)} - MYR {numberWithCommas(selectedBank.maximumDeposit)}
                                                </div>
                                            </div>

                                            <div className="deposit-normal-bank-details-item mt-3">
                                                <div className="first">
                                                    {t("TRANSFER_REFERENCE")}
                                                </div>
                                                <div className="second">
                                                    <div>
                                                        {bankReference}
                                                    </div>
                                                    <div className="copy" onClick={() => copyText(bankReference)}>
                                                        <img
                                                            src={CopyIcon}
                                                            alt="i8 banks"
                                                            className="img-responsive"
                                                            loading="lazy"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="custom-hr" />
                            <div className="normal-bank-per-section-box">
                                <div className="first">
                                    {t("AMOUNT")}
                                </div>
                                <div className="second ">
                                    <div className="form-group m-b-15 px-0">
                                        <div className="deposit-input-group mb-3">
                                            <span className="currency-prefix">MYR</span>
                                            {<input
                                                type="text"
                                                className="form-white-input normal-deposit-input"
                                                placeholder={t("PLEASE_ENTER_AMOUNT")}
                                                value={numberWithCommas(amountValue)}
                                                onChange={(event) => {
                                                    let tempValue = event.target.value.replace(/[^0-9]/g, '');
                                                    setAmountValue(tempValue);
                                                    checkAmountForErrors(tempValue);
                                                }}
                                                onPaste={(event) => {
                                                    if (!stringIsNullOrEmpty(window.event.clipboardData.getData('text')) && (/^[1-9]{1,}[0-9]{0,}$/).test(window.event.clipboardData.getData('text'))) {
                                                        setAmountValue(parseInt(window.event.clipboardData.getData('text')));
                                                        event.preventDefault();
                                                    } else {
                                                        setAmountValue('');
                                                        event.preventDefault();
                                                    }
                                                }}
                                            />}
                                            <div className="clear-amount">
                                                <Icon
                                                    path={mdiClose}
                                                    size={1}
                                                    color="#FF0808"
                                                    onClick={() => {
                                                        setAmountValue("");
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {errors.amount && (
                                            <div className="invalid-feedback">{t(errors.amount.message)}</div>
                                        )}
                                        <div className="font-11 color-white">
                                            {parseFloat(amountValue) >= min ?
                                                <>
                                                    <span>{t("MAIN_WALLET_NEW_BALANCE") + " : "}</span>
                                                    <span>{numberWithCurrencyFormat2(parseFloat(_userData.walletBalance), 2, true) + " "}</span>
                                                    <i className="fas fa-arrow-right" />
                                                    <span>{" " + numberWithCurrencyFormat2(parseFloat(_userData.walletBalance) + (amountValue > 0 ? parseFloat(amountValue) : 0), 2, true)}</span>
                                                </>
                                                :
                                                <>
                                                </>
                                            }
                                        </div>
                                        <div>
                                            {min >= 0 && max >= 0 && (
                                                <div className="font-11 amount-limit-reminder">
                                                    <span className="reminder mr-2">
                                                        * {t("MIN")} : MYR {numberWithCommas(min)} / {t("MAX")} : MYR {numberWithCommas(max)}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="amount-row">
                                        {fixedAmount.map((amount, index) => {
                                            return (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    onClick={() => checkValueOnSelectFixedAmt(amount)}
                                                    className="btn custom-button"
                                                >
                                                    + {numberWithCommas(amount)}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <hr className="custom-hr" />
                            <div className="normal-bank-per-section-box">
                                <div className="first">
                                    {t("RECEIPT_REFERENCE")}
                                </div>
                                <div className="second ">
                                    <div className="form-divider mt-4">
                                        <div className="withdrawal-name-alert alert alert-warning mb-0">
                                            <div className="withdrawal-warning-text">
                                                <div className="img-wrapper">
                                                    <img className="blue-warning-icon" src={BlueWarningIcon} alt="deposit receipt reference" loading="lazy" />
                                                </div>
                                                <div className="text-wrapper" >
                                                    <span className="text-yellow-lighter"><b>{t("FRINEDLY_REMINDER")}</b></span>{t("DEPOSIT_RECEIPT_REFERENCE")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="custom-hr" />
                            <div className="normal-bank-per-section-box">
                                <div className="first">
                                    {t("RECEIPT")}<br />
                                    {" (" + t("MAX_FILE_SIZE") + ": " + fileSizeLimit_InMB + "MB)"}
                                </div>
                                <div className="second ">
                                    <div>
                                        <Controller
                                            control={control}
                                            name="receipt"
                                            defaultValue={""}
                                            rules={{ required: t("PLEASE_ATTACH_RECEIPT") }}
                                            render={({ onChange, value }) => {
                                                return (
                                                    <>
                                                        <Dropzone
                                                            accept={"image/*"}
                                                            onDrop={(acceptedFiles) => imageDrop(acceptedFiles)}
                                                            maxSize={fileSizeLimit_InMB * ONE_MB_IN_BYTES}
                                                            onDropRejected={() =>
                                                                _dispatch(
                                                                    showResponseMessage(
                                                                        false,
                                                                        t("FILE_LARGER_THAN") +
                                                                        fileSizeLimit_InMB +
                                                                        "MB, " +
                                                                        t("PLEASE_TRY_AGAIN")
                                                                    )
                                                                )
                                                            }
                                                        >
                                                            {({ getRootProps, getInputProps }) => (
                                                                <div>
                                                                    <section style={{ position: "relative" }}>
                                                                        {!stringIsNullOrEmpty(receiptImage) && (
                                                                            <div
                                                                                style={{
                                                                                    background: "transparent",
                                                                                    padding: "5px 10px",
                                                                                    textAlign: "center",
                                                                                    position: "absolute",
                                                                                    right: "5px",
                                                                                    top: "5px",
                                                                                }}
                                                                                onClick={() => remove()}
                                                                            >
                                                                                <i className="fa fa-trash text-red"></i>
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            className="dropzone"
                                                                            style={{ minHeight: "100px", textAlign: "center" }}
                                                                            {...getRootProps()}
                                                                        >
                                                                            <input {...getInputProps()} />
                                                                            {stringIsNullOrEmpty(receiptImage) && (
                                                                                <h4 style={{ color: "grey" }}>
                                                                                    {t(
                                                                                        "DRAG_N_DROP_SOME_FILES_HERE_OR_CLICK_TO_SELECT_FILES"
                                                                                    )}
                                                                                </h4>
                                                                            )}
                                                                            {!stringIsNullOrEmpty(receiptImage) && (
                                                                                <aside className="thumbsContainer">
                                                                                    <div className="thumb">
                                                                                        <div className="thumbInner">
                                                                                            <img
                                                                                                src={receiptImage}
                                                                                                className="dropzone-img"
                                                                                                alt="dropzone-img"
                                                                                                loading="lazy"
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </aside>
                                                                            )}
                                                                        </div>
                                                                    </section>
                                                                    {!stringIsNullOrEmpty(receiptImage) ? (
                                                                        <div style={{ color: "#002e6c", fontSize: "15px" }}>
                                                                            {t("UPLOADED_FILE_SIZE") +
                                                                                ": " +
                                                                                numberWithCurrencyFormat(imageFileSize, 2, true) +
                                                                                "MB"}
                                                                        </div>
                                                                    ) : (
                                                                        <div></div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </Dropzone>
                                                        {errors.receipt && (
                                                            <div className="invalid-feedback">{t(errors.receipt.message)}</div>
                                                        )}
                                                    </>
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {bankIsSelected && (
                        <>
                            <div className="form-group mb-4">
                                <label className="font-15 text-white font-semi mb-3">

                                </label>

                            </div>
                            <div className="form-group mt-3 col-md-12 px-0">
                                <button type="submit" className="custom-btn-style-1">
                                    {t("SUBMIT")}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </form>
            <Modal
                fade={false}
                contentClassName="modal-brand modal-bottom modal-reload-success"
                isOpen={isReloadSuccess}
                toggle={() => {
                    setIsReloadSuccess(false);
                }}
                centered
            >
                <ModalBody>
                    <div className="text-center">
                        <strong className="reload-title text-yellow mb-3 d-block">
                            {t("RELOAD_SUCCESS")}
                        </strong>
                        <div className="text-brand text-bo">
                            {t("PAID_DEPOSIT", { amount: paidAmount })}
                        </div>
                    </div>
                    <table className="table text-brand table-reload-detail">
                        <tr>
                            <th>{t("DEPOSIT_DATE_TIME")}</th>
                            <th style={{ textAlign: "right" }}>{reloadDate}</th>
                        </tr>
                        <tr>
                            <th>{t("REFERENCE_NUMBER")}</th>
                            <th style={{ textAlign: "right" }}>{transcactionNumber}</th>
                        </tr>
                    </table>
                    <button
                        className="custom-btn-style-1"
                        onClick={() => {
                            handleModalOnClick();
                        }}
                    >
                        {t("DONE")}
                    </button>
                </ModalBody>
            </Modal>
        </>
    );
};

export default NormalDeposit;